"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windowApiKeyReceivedEventKey = exports.apiBaseUrl = void 0;
const apiBaseUrl = exports.apiBaseUrl = 'https://public.api.fjordmail.no/v1';
const windowApiKeyReceivedEventKey = exports.windowApiKeyReceivedEventKey = 'recurrentApiKeysReceived';